var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"wx_error",attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":12}},[_c('i',{staticClass:"el-icon-warning"}),_c('br'),_vm._v(_vm._s(_vm.msg))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e23264d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/weChat/WxError.vue
// module id = jQWn
// module chunks = 2